import { render, staticRenderFns } from "./roadmap.vue?vue&type=template&id=79780e23&scoped=true&"
import script from "./roadmap.vue?vue&type=script&lang=ts&"
export * from "./roadmap.vue?vue&type=script&lang=ts&"
import style0 from "./roadmap.vue?vue&type=style&index=0&id=79780e23&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79780e23",
  null
  
)

export default component.exports